import { LegalClientTargetedFinancialInstrumentsEntity } from 'api/types/entity/legal/legalClientTargetedFinancialInstrumentsEntity';

import { TargetedFinancialInstrumentsFormType } from '../../forms/targetedFinancialInstrumentsForm';

const parseFinancialInstrument = (
  data: LegalClientTargetedFinancialInstrumentsEntity['financialInstruments']['bonds']
) => ({
  enabled: !!data,
  yearlyTradeAmount: data?.yearlyTradeAmount,
  monthlyTradeAmount: data?.monthlyTradeAmount ?? undefined,
});

export const getInitialData = (
  targetedFinancialInstruments:
    | LegalClientTargetedFinancialInstrumentsEntity
    | undefined
) => {
  const values: TargetedFinancialInstrumentsFormType | undefined =
    targetedFinancialInstruments
      ? {
          expectedMonthlyTradeQuantity:
            targetedFinancialInstruments.operationsDetails
              .expectedMonthlyTradeQuantity,
          expectedYearlyTradeQuantity:
            targetedFinancialInstruments.operationsDetails
              .expectedYearlyTradeQuantity,

          financialInstruments: {
            bonds: parseFinancialInstrument(
              targetedFinancialInstruments.financialInstruments.bonds
            ),
            derivatives: parseFinancialInstrument(
              targetedFinancialInstruments.financialInstruments.derivatives
            ),
            mutualFunds: parseFinancialInstrument(
              targetedFinancialInstruments.financialInstruments.mutualFunds
            ),
            stocks: parseFinancialInstrument(
              targetedFinancialInstruments.financialInstruments.stocks
            ),
            structuredProducts: parseFinancialInstrument(
              targetedFinancialInstruments.financialInstruments
                .structuredProducts
            ),
            otherFinancialInstruments: parseFinancialInstrument(
              targetedFinancialInstruments.financialInstruments
                .otherFinancialInstruments
            ),
          },
        }
      : undefined;

  return values;
};
